import { CloseButton as ChakraCloseButton, CloseButtonProps as ChakraCloseButtonProps } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { primaryThemeGradient, primaryThemeGradientDark } from 'constants/theme';

const CloseButtonStyles: ComponentStyleConfig = {
  baseStyle: {},
  variants: {
    modal: {
      bg: primaryThemeGradient,
      borderRadius: '100%',
      position: 'absolute',
      color: 'primaryFontColour.400',
      top: '-1rem',
      right: '-1rem',
      _focus: {
        boxShadow: 'none',
        bg: primaryThemeGradientDark,
      },
      _hover: {
        bg: primaryThemeGradientDark,
      },
    },
  },
};

const CloseButton = ({ children, ...props }: ChakraCloseButtonProps) => (
  <ChakraCloseButton {...props}>{children}</ChakraCloseButton>
);

export { CloseButton, CloseButtonStyles };
